import { CodeStatus } from '../code-common/interface';

export const dataEditCodeDefault = {
  status: CodeStatus.IN_ACTIVE,
  useTime: 1,
};

export const Type_Get_Code = 'CODE';
